import { ScheduleDateTimeModal } from "@/features/shared/ScheduleDateTimeModal";

type Props = {
  open: boolean;
  subject?: string;
  busy?: boolean;
  onConfirm: (untilIso: string) => void;
  onClose: () => void;
};

export function SnoozeModal({ open, subject, busy = false, onConfirm, onClose }: Props) {
  return (
    <ScheduleDateTimeModal
      open={open}
      title="Mettre en attente"
      subject={subject}
      description="Choisissez quand réafficher ce message"
      confirmLabel="Mettre en attente"
      previewPrefix="Réapparition le"
      busy={busy}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
}
